import React from 'react';
import { Modal, ModalProps } from 'antd';
import { ModalFuncProps } from 'antd/lib/modal';
import styles from './index.module.less';
import Iconfont from '@base/lib/Iconfont';
import cn from 'classnames';
import { ct } from 'base/utils/i18n';

type IProps = ModalFuncProps & {
    severity?: 'strong' | 'weak';
};

export function msgModal(props: IProps): void {
    const { severity = 'strong', ...rest } = props;
    const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

    const modalProps = severity === 'strong' ? {
        closable: false,
        maskClosable: false,
    } : {
        closable: true,
        maskClosable: true,
        okCancel: false
    };

    Modal.info({
        className: cn(styles['msg-modal'], styles[severity]),
        icon: false,
        centered: true,
        closeIcon: <Iconfont className="icon-x"/>,
        width: isPhone ? '74%' : (props.width || 370),
        okText: ct('web_common_btn_ok'),
        ...modalProps,
        ...rest,
    });
}

export function confimModal(props: ModalFuncProps): void {
    Modal.confirm({
        className: styles['confirm-modal'],
        width: 542,
        icon: null,
        centered: true,
        okText: ct('web_common_btn_yes'),
        cancelText: ct('web_common_btn_no'),
        okButtonProps: { type: 'link', className: styles['btn-ok'] },
        cancelButtonProps: { type: 'text', className: styles['btn-cancel'] },
        ...props
    });
}

export type IThemeModalProps = ModalProps;

export function ThemeModal(props: IThemeModalProps): React.ReactElement {
    const { className, ...rest } = props;

    return (
        <Modal
            className={cn(styles.modal, className)}
            closeIcon={<Iconfont className="icon-x"/>}
            centered
            footer={false}
            {...rest}
        />
    )
}